import BaseService from './base.service';

export default class UserNotificationsService {
    static ENDPOINT = '/notifications';

    static async markAllRead() {
        const endpoint = `${this.ENDPOINT}/mark-all-read`;
        return BaseService.post(endpoint);
    }

    // The caller's notification preferences: the catalog rows they may see, each with its
    // effective value already merged in. The server owns the rows and the defaults.
    static async getPreferences() {
        return BaseService.get(`${this.ENDPOINT}/preferences`);
    }

    // `patch` is partial, e.g. `{ categories: { invite_approval: false } }`. Answers with the
    // same shape as `getPreferences`, so no second call is needed.
    static async updatePreferences(patch) {
        return BaseService.patch(`${this.ENDPOINT}/preferences`, patch);
    }
}
